import React, {Component} from "react";
import './upload-button.css'
import ButtonIcon from "../../button";
import { PDF_Extension, UPLOAD_NOTIFICATION_MESSAGE } from "../../../constants/external-constants";
import { NotificationModal } from "../modal/notification-modal.component";
import Icons from "../../icon";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { displayFinalFileName } from "../../../utils/helpers.utils";

class UploadButton extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            inputValue: "",
            fileList: "",
            fileListData: null,
            showModal: false,
            showConModal: false,
            modalMessage: "",
            uploadedFileName: ""
        }
    }

    handleConfirmationModal = () => {
        this.setState(prevState=>({ showModal: !prevState.showModal}));
    }

    handleClearFileName = () => {
        this.setState({
            showConModal:true
        });
    }

    handleConfModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState({
                uploadedFileName: "",
                fileListData: null,
                showConModal: false
            });
            if (this.props.onChange) {
                this.props.onChange("");
            }
        }else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleFileChange = (event) => {    
        const file = event.target.files[0];
        const filename = file.name;
        const extIndex = filename.lastIndexOf('.');
        const newName = filename.substring(0, Math.min(extIndex, 20));
        const extension = filename.substring(extIndex + 1);
        const finalName = extIndex > 20 ? `${newName}...${extension}` : filename;
        const allowedExtensions = PDF_Extension;
        if (file.size <= 10 * 1024 * 1024) {
            if (allowedExtensions.includes(extension)) {
                this.setState({
                    uploadedFileName: finalName,
                    fileList: finalName,
                    fileListData: file
                });
            } else {
                this.setState({
                    showModal: true,
                    modalMessage: `Only files with the following format are allowed: ${(allowedExtensions + " ")}`
                });
            }
        } else {
            this.setState({
                showModal: true,
                modalMessage: "Total file size exceeds the allowable limit of 10 MB"
            });
        }

        if (this.props.onChange) {
            this.props.onChange(filename);
        }
    };

    fileUploadButton = () => {
        const { uploadedFileName } = this.state;

        if (!uploadedFileName) {
            return (
                this.props.isReadAndWrite &&
                <ButtonIcon onClick={() => this.fileRef.current.click()} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Choose File">
                    <input className="upload-file-btn" type="file" ref={this.fileRef} onChange={this.handleFileChange} accept=".pdf" />
                </ButtonIcon>
            );
        }

        return null;
    }
    

    uploadFileIndicator = () =>{
        const { uploadedFileName } = this.state;

        return (
            <div className={`file-title ${uploadedFileName ? 'attached-file' : ""} ${!this.props.isReadOnly ? 'pointer' : ''}`}>
                {uploadedFileName ? (
                    <>
                        <Icons
                            customClassName="icon-file-clip"
                            name="paper-clip-solid"
                            size="15px"
                            containerClass="icon-paper-clip-file-container"
                        />
                        <span onClick={this.props.isReadOnly ? null : this.props.onClickExtract}>{displayFinalFileName(uploadedFileName)}</span>
                        {this.props.isReadAndWrite &&
                            <span className="close-btn" onClick={this.props.isReadOnly ? null : this.handleClearFileName}>x</span>
                        }
                    </>
                ) : "no file selected"}
            </div>
        );
    }

    inputFileValue = () => {
        return this.state.fileListData;
    }

    setUploadFileName(fileName) {
        this.setState({
            uploadedFileName: fileName
        });
    }

    render() {       
        const { showModal, modalMessage } = this.state;

        return (
            <div className="upload-layout-containers">  
                <div className="upload-button-container">  
                    <span className="title">Invoice PDF</span>
                    <div className="upload-button-item">
                            {this.fileUploadButton()}
                            {this.uploadFileIndicator()}
                        </div>
                </div>  
                <ConfirmationNotificationModal
                    show={this.state.showConModal}
                    message={UPLOAD_NOTIFICATION_MESSAGE.RemoveFile}
                    title="Confirmation"
                    handleModal={this.handleConfModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <NotificationModal title="Confirmation" show={showModal} customClass="comment-notification-modal notification-footer" handleModal={this.handleConfirmationModal} message={modalMessage} />             
            </div>
        );
    }
}

export default UploadButton;